import React from 'react'
import Icon from '../../atoms/Icon/Icon'
import { AlertTriangleLine, Checkmark } from '../NewIcons'

export interface FormFieldProps {
  id?: string
  label?: string
  subtitle?: string
  variant?: 'no-icon' | 'left-icon' | 'right-icon'
  styleVariant?: 'default' | 'editor'
  iconName?: string
  status?: 'no-status' | 'success' | 'error' | 'warning' | 'info'
  size?: 'sm' | 'md' | 'lg'
  errorMessage?: string
  infoMessage?: string
  children?: React.ReactNode
  layout?: 'block' | 'full'
  onBlur?: (e: any) => void,
  className?: string
}

const FormField = (props: FormFieldProps) => {

  const {
    id,
    label,
    subtitle,
    variant = 'no-icon',
    styleVariant = 'default',
    iconName,
    status = 'no-status',
    size = 'md',
    errorMessage,
    infoMessage,
    children,
    layout,
    onBlur,
    className,
  } = props

  return (
    <div
      onBlur={onBlur}
      className={
        `formfield` +
        (size ? ` formfield--${size}` : '') +
        (variant ? ` formfield--${variant}` : '') +
        (styleVariant ? ` formfield--${styleVariant}` : '') +
        (status ? ` formfield--${status}` : '') +
        (layout ? ` formfield--layout-${layout}` : '') +
        (className ? ' ' + className : '')
      }
    >
      {label ? <label className="formfield__label" htmlFor={id}>{label}{subtitle && <span className='formfield__subtitle'>{subtitle}</span>}</label> : ''}
      <div className="formfield__input-wrapper">
        {children}
        {iconName ? (
          <Icon icon_name={iconName} cName={'formfield__icon'} size={size == 'lg' ? 24 : 20} />
        ) : (
          <></>
        )}
        {status === 'error' || status === 'warning' || status === 'info' ? (
          <div className={'formfield__error-icon'}>
            {' '}
            <AlertTriangleLine />
          </div>
        ) : (
          <></>
        )}
        {status === 'success' ? (
          <div className={'formfield__success-icon'}>
            <Checkmark />
          </div>
        ) : (
          <></>
        )}
      </div>
      {status === 'error' && errorMessage ? (
        <div className="formfield__error">{errorMessage}</div>
      ) : (
        <></>
      )}
      {infoMessage ? <div className="formfield__info">{infoMessage}</div> : <></>}
    </div>
  )
}

export default FormField
